module.exports = __webpack_public_path__ + "static/media/14.e43ec083.png";